import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';

export const useQuestionnaire = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isAuthenticated, openAuthModal } = useAuth();
  const navigate = useNavigate();

  const handleStartQuestionnaire = () => {
    if (!isAuthenticated) {
      openAuthModal();
      return;
    }
    setIsModalOpen(true);
  };

  const handleQuestionnaireComplete = async (responses: any) => {
    try {
      // Save responses to local storage for profile access
      localStorage.setItem('careerAssessment', JSON.stringify({
        responses,
        date: new Date().toISOString()
      }));
      
      // Show success message
      toast.success('Assessment saved! Redirecting to career comparison...');
      
      // Close modal
      setIsModalOpen(false);
      
      // Navigate to career comparison page
      navigate('/compare', { state: { responses } });
    } catch (error) {
      console.error('Error saving questionnaire responses:', error);
      toast.error('Something went wrong. Please try again.');
    }
  };

  return {
    isModalOpen,
    setIsModalOpen,
    handleStartQuestionnaire,
    handleQuestionnaireComplete
  };
};